import "./ManagedServices.module.css";
import Header from "@/reusable_sections/Header";
import TheLandWeTend from "./sections/TheLandWeTend";
import OurPavingLandscapingExpertise from "./sections/OurPavingLandscapingExpertise";
import OnboardingJourney from "./sections/OnboardingProcess";
import Footer from "@/reusable_sections/Footer";
export default function ManagedServicesPage() {
  return <div>
      <Header />
      <TheLandWeTend />
      <OurPavingLandscapingExpertise />
      <OnboardingJourney />
      <Footer />
    </div>;
}